import { makeAutoObservable } from "mobx"

export class YandexCaptchaStore
{
	constructor()
	{
		makeAutoObservable(this, {});

		if (!(window as any).YandexCaptchaScript)
		{
			(window as any).YandexCaptchaScript = document.createElement('script');
			(window as any).YandexCaptchaScript.src = "https://captcha-api.yandex.ru/captcha.js";
			document.body.appendChild((window as any).YandexCaptchaScript);
		}

		if (!(window as any).YandexCaptchaCallback)
		{
			(window as any).YandexCaptchaCallback = function (token: string)
			{
				debugger;
			}
		}
	}

	public PublicKey: string = "";
	public setPublicKey(publicKey: string)
	{
		this.PublicKey = publicKey;
	}

	public Enabled: boolean = false;
	public setEnabled(enabled: boolean)
	{
		this.Enabled = enabled;
	}

	public Callback: (token: string) => void = (token: string) => { };
	public setCallback(callback: (token: string) => void)
	{
		this.Callback = callback;
	}

	public ShowModal: boolean = false;
	public setShowModal(showModal:boolean)
	{
		this.ShowModal = showModal;
	}

	public Solve(callback:(token:string)=>void): void
	{
		if (this.Enabled)
		{
			this.setCallback(callback);
			this.setShowModal(true);
		}
		else
		{
			callback('disabled');
		}
	}

}
